package com.pincer.core.model.drafts

import com.pincer.core.InvalidData
import com.pincer.core.model.tree.Question

/*
Drafts hold what someone has typed into the app but not yet submitted, one per loaded pincer (PincerPack.ui).
A null field means "nothing typed, show the real value". They never go over the wire and have no diff/apply:
submitting a draft means copying its values onto the local Pincer, which the client then diffs into a patch.

Until September 2026 these were the PincerPatch classes themselves, doing double duty.
*/

class PincerDraft {
    var name         : String? = null
    var description  : String? = null
    var openRole     : String? = null
    var rules        : String? = null
    val questions    : MutableMap<String, QuestionDraft> = mutableMapOf()
    val participants : MutableMap<String, ParticipantDraft> = mutableMapOf()

    fun getOrAddParticipant(principalId: String): ParticipantDraft = participants.getOrPut(principalId) { ParticipantDraft() }
    fun getOrAddQuestion(questionId: String): QuestionDraft = questions.getOrPut(questionId) { QuestionDraft() }
}

class ParticipantDraft {
    var name       : String? = null
    var redRules   : String? = null
    var greenRules : String? = null
    val answers    : MutableMap<String, AnswerDraft> = mutableMapOf()

    fun getOrAddAnswer(questionId: String): AnswerDraft = answers.getOrPut(questionId) { AnswerDraft() }
}

class QuestionDraft(
    var format   : String? = null,
    var code     : String? = null,
    var wording  : String? = null,
    var helpText : String? = null,
    var options  : String? = null,
    var regex    : String? = null,
    var roles    : String? = null,
) {
    fun asQuestion(): Question {
        val question = Question(
            wording = wording ?: throw InvalidData(),
            code    = code    ?: throw InvalidData(),
        )
        if (format   != null) question.format   = format!!
        if (helpText != null) question.helpText = helpText
        if (options  != null) question.options  = options
        if (regex    != null) question.regex    = regex
        if (roles    != null) question.roles    = roles
        return question
    }
}

class AnswerDraft {
    var wording : String? = null
}
